import React, { HTMLAttributes } from "react";
import styled from "styled-components";

const Wrapper = styled.div<ISelectComponent>`
  border: ${(props) => props.selected? '1px solid #C41230':'1px solid #e0e0e0'};
  padding: 1px 4px;
  color: #C41230;
  margin-left: 6px;
  text-align: center;
  text-overflow: ellipsis;
  min-width: 70px;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 3px;
  font-size: 12px;
  cursor: pointer;
`;

function BadgeFilter({ children, ...rest }: IBadgeFilter) {
  return <Wrapper {...rest}>{children}</Wrapper>;
}

export interface IBadgeFilter
  extends HTMLAttributes<HTMLDivElement>,
    ISelectComponent {
  children: React.ReactChild;
}

export interface ISelectComponent {
  selected?: boolean;
}

export default BadgeFilter;
